export default __webpack_public_path__ + "static/stetho-e1bd05e65f4259bfce9505f4b5ab63b9.jpg";